export const RECEIVED_MARKERS = 'RECEIVED_MARKERS';
export const RECEIVED_LOCATIONS = 'RECEIVED_LOCATIONS';
export const MAP_CHECKBOX_UNCHANGED = 'MAP_CHECKBOX_UNCHANGED';
export const MAP_DESELECT_ALL_CHECKBOX = 'MAP_DESELECT_ALL_CHECKBOX';
export const MAP_SELECT_ALL_CHECKBOX = 'MAP_SELECT_ALL_CHECKBOX';
export const ORDER_REMOVE_LOCATION = 'ORDER_REMOVE_LOCATION';
export const DROPPING_ANIMATION_START = 'DROPPING_ANIMATION_START';
export const DROPPING_ANIMATION_FINISH = 'DROPPING_ANIMATION_FINISH';
export const FLYING_ANIMATION_START = 'FLYING_ANIMATION_START';
export const FLYING_ANIMATION_FINISH = 'FLYING_ANIMATION_FINISH';
export const CLEAN_ORDERS = 'CLEAN_ORDERS';
export const DISABLE_SUBMIT = 'DISABLE_SUBMIT';
